/**
 * Keep cart-drawer upsell details open for the side-panel layout (>= 420px)
 * and restore the accordion open state below that breakpoint.
 */
(function () {
  const MQ = window.matchMedia('(min-width: 420px)');
  const SELECTOR = 'cart-drawer [data-drawer-side-upsell]';

  function syncDrawerUpsellOpenState() {
    document.querySelectorAll(SELECTOR).forEach((widget) => {
      const body = widget.querySelector('[data-collapsible-body]');

      if (MQ.matches) {
        if (!widget.hasAttribute('data-upsell-prefer-closed')) {
          widget.setAttribute(
            'data-upsell-prefer-closed',
            widget.hasAttribute('open') ? 'false' : 'true'
          );
        }

        widget.setAttribute('open', '');
        if (body) body.style.height = 'auto';
        return;
      }

      const preferClosed = widget.getAttribute('data-upsell-prefer-closed') === 'true';
      const autoOpen = widget.hasAttribute('data-upsell-auto-open');

      if (preferClosed && !autoOpen) {
        widget.removeAttribute('open');
        if (body) body.style.height = '';
      } else {
        widget.setAttribute('open', '');
        if (body) body.style.height = 'auto';
      }
    });
  }

  document.addEventListener('theme:cart-drawer:open', syncDrawerUpsellOpenState);
  document.addEventListener('theme:cart:change', () => {
    requestAnimationFrame(syncDrawerUpsellOpenState);
  });

  if (typeof MQ.addEventListener === 'function') {
    MQ.addEventListener('change', syncDrawerUpsellOpenState);
  } else if (typeof MQ.addListener === 'function') {
    MQ.addListener(syncDrawerUpsellOpenState);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncDrawerUpsellOpenState);
  } else {
    syncDrawerUpsellOpenState();
  }
})();
